<template>
  <div class="page">
    <div class="title-row">
      <span class="page-title">护理人员</span>
      <el-tag type="info" size="small">仅护理人员可参与排班</el-tag>
    </div>

    <!-- 搜索栏 -->
    <div class="filter-bar">
      <el-input v-model="formModel.userName" placeholder="请输入姓名" clearable size="small" style="width:200px" @keyup.enter.native="handleSearch"></el-input>
      <el-button type="primary" size="small" :loading="loading" @click="handleSearch" style="margin-left:8px">
        <i class="el-icon-search"></i> 查询
      </el-button>
      <el-button size="small" @click="resetForm" style="margin-left:6px">重置</el-button>
      <span style="margin-left:16px;font-size:13px;color:#64748B">共 <b>{{ total }}</b> 名护理人员</span>
    </div>

    <!-- 表格 -->
    <div class="main-card">
      <el-table :data="tableData" v-loading="loading" :border="false" stripe size="medium" style="width:100%">
        <el-table-column type="index" label="序号" width="64" align="center">
          <template slot-scope="{ $index }">{{ (pageNum - 1) * pageSize + $index + 1 }}</template>
        </el-table-column>
        <el-table-column label="姓名" width="160">
          <template slot-scope="{ row }">
            <div style="display:flex;align-items:center;">
              <span class="staff-avatar" :style="{ background: getAvatarColor(row.userId) }">
                {{ (row.realName || row.userName || '?').charAt(0) }}
              </span>
              <div style="margin-left:8px">
                <div style="font-weight:600;color:#1E293B">{{ row.realName }}</div>
                <div style="font-size:11px;color:#94A3B8">{{ row.userName }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="性别" width="72" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.sex === 0 ? 'primary' : 'danger'" size="mini">
              {{ row.sex === 0 ? '男' : row.sex === 1 ? '女' : '—' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="联系电话" width="140">
          <template slot-scope="{ row }">
            <span style="font-family:monospace">{{ row.phone || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属班组" width="140">
          <template slot-scope="{ row }">
            <el-tag v-if="row.nursingGroupName" type="success" size="mini">{{ row.nursingGroupName }}</el-tag>
            <span v-else style="font-size:12px;color:#CBD5E1">未分配</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" width="120">
          <template slot-scope="{ row }">
            <span style="font-size:12px;color:#64748B">{{ row.roleName || '护理员' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="今日排班" width="100" align="center">
          <template slot-scope="{ row }">
            <el-badge v-if="getTodaySchedule(row.userId)" is-dot type="success">
              <span style="font-size:12px;color:#10B981">今日在班</span>
            </el-badge>
            <span v-else style="font-size:12px;color:#94A3B8">今日休息</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination
          :current-page="pageNum"
          :page-size="pageSize"
          :total="total"
          :page-sizes="[20, 50, 100]"
          layout="total, sizes, prev, pager, next"
          @current-change="onPageChange"
          @size-change="onSizeChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getNursingStaffList, getRoomScheduleList } from './scheduleApi'
import { getAvatarColor, getTodayStr } from './scheduleUtils'

export default {
  name: 'NursingStaff',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 20,
      formModel: { userName: '' },
      todayStaffIds: new Set(),
      todayStr: getTodayStr()
    }
  },
  mounted() {
    this.loadList()
    this.loadTodaySchedule()
  },
  methods: {
    getAvatarColor,
    loadList() {
      this.loading = true
      getNursingStaffList({
        userName: this.formModel.userName || undefined,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        if (res && res.code == 200) {
          const data = res.result || res
          this.tableData = data.list || data.records || (Array.isArray(data) ? data : [])
          this.total = data.total || this.tableData.length
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    async loadTodaySchedule() {
      try {
        const res = await getRoomScheduleList({ weekStart: this.todayStr, weekEnd: this.todayStr, pageSize: 500 })
        if (res && res.code == 200) {
          const data = res.result || res
          const list = data.list || data.records || (Array.isArray(data) ? data : [])
          this.todayStaffIds = new Set(list.map(s => String(s.staffId)))
        }
      } catch { /* silent */ }
    },
    getTodaySchedule(userId) {
      return this.todayStaffIds.has(String(userId))
    },
    handleSearch() { this.pageNum = 1; this.loadList() },
    resetForm() { this.formModel.userName = ''; this.pageNum = 1; this.loadList() },
    onPageChange(page) { this.pageNum = page; this.loadList() },
    onSizeChange(size) { this.pageSize = size; this.pageNum = 1; this.loadList() }
  }
}
</script>

<style scoped>
.page { padding: 0 16px; height: calc(100vh - 56px); display: flex; flex-direction: column; overflow: hidden; }
.title-row { display: flex; justify-content: space-between; align-items: center; flex-shrink: 0; padding: 8px 0 4px; }
.page-title { font-size: 18px; font-weight: 700; color: #1E293B; }
.filter-bar { display: flex; align-items: center; flex-shrink: 0; padding: 8px 0; border-bottom: 1px solid #E2E8F0; margin-bottom: 8px; }
.main-card { flex: 1; min-height: 0; overflow-y: auto; background: #fff; border-radius: 10px; border: 1px solid #E2E8F0; box-shadow: 0 1px 6px rgba(0,0,0,0.04); display: flex; flex-direction: column; }
.staff-avatar { width: 30px; height: 30px; border-radius: 50%; flex-shrink: 0; color: #fff; font-size: 12px; font-weight: 700; display: inline-flex; align-items: center; justify-content: center; }
.pagination-wrap { display: flex; justify-content: flex-end; padding: 12px 16px; border-top: 1px solid #F1F5F9; flex-shrink: 0; }
</style>
